module.exports = __webpack_public_path__ + "img/soical-mesage.7037beac.png";